import React, { useState, useEffect } from "react";
import flashy from '@pablotheblink/flashyjs';
import { useNotix } from "../components/Notix/Notix";
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signInWithPopup,
  sendPasswordResetEmail // <-- Añade esto
} from "firebase/auth";
import { auth, googleProvider } from "../firebase";
import "./Login.css";
import Privacy from "./Privacy";
import Modal from "./Modal";
import CookieBanner from "./CookieBanner";
import { useNavigate } from "react-router-dom";

const Login = ({ onBack, onSignup, onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const navigate = useNavigate();
  const notix = useNotix();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      if (currentUser && onLoginSuccess) {
        onLoginSuccess(currentUser); // Cambia la vista a "main"
      }
    });
    return () => unsubscribe();
  }, [onLoginSuccess]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      console.log("Usuario logueado:", userCredential.user);
      setEmail("");
      setPassword("");
      navigate("/app"); // Redirige a la aplicación principal
    } catch (error) {
      alert("Error al iniciar sesión: " + error.message);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      navigate("/app"); // Redirige a la aplicación principal
    } catch (error) {
      flashy.error('Error con Google' + error.message, {
        position: 'top-center'
      });
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      notix.error("Introduce tu correo electrónico para recuperar la contraseña.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      notix.success("Correo de recuperación enviado. Revisa tu bandeja de entrada y la carpeta de spam.");
    } catch (error) {
      notix.error("Error: " + error.message);
    }
  };

  return (
    <div className="login-container">
      {user ? (
        <div>
          <h2>¡Bienvenido, {user.email}!</h2>
          <button onClick={() => auth.signOut()}>Cerrar sesión</button>
        </div>
      ) : (
        <form className="login-form" onSubmit={handleLogin}>
          <h2>Login</h2>
          <p className="login-description">
            Introduce tu correo electrónico y tu contraseña para acceder a tu cuenta
          </p>

          <label htmlFor="email">Correo Electrónico</label>
          <input
            type="email"
            id="email"
            required
            value={email}
            placeholder="name@example.com"
            onChange={(e) => setEmail(e.target.value)}
          />

          <label htmlFor="password">Contraseña</label>
          <input
            type="password"
            id="password"
            required
            value={password}
            placeholder="********"
            onChange={(e) => setPassword(e.target.value)}
          />

          <button
            type="button"
            className="forgot-password"
            onClick={handleForgotPassword}
          >
            ¿Olvidaste tu contraseña?
          </button>

          <button type="submit" className="sign-in-button">
            Entrar
          </button>

          <button
            type="button"
            className="google-signin-button"
            onClick={handleGoogleLogin}
          >
            Iniciar sesión con <span className="google-text-gradient">Google</span>
          </button>

          <button type="button" className="back-button" onClick={onBack}>
            Volver
          </button>

          <p className="signup-link">
            ¿No tienes cuenta?{" "}
            <button
              type="button"
              className="link-button"
              onClick={() => navigate("/signup")}
            >
              Sign up
            </button>
          </p>

          <button
            type="button"
            className="privacy-btn"
            style={{ marginTop: 24, background: "none", border: "none", color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => setShowPrivacy(true)}
          >
            Política de Privacidad
          </button>

          <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)}>
            <Privacy />
          </Modal>
        </form>
      )}
      <CookieBanner />
    </div>
  );
};

export default Login;
